import { StrictMode, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { CollableThemeProvider, ToastPopupProvider } from '@collable/ui'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './context/AuthContext.tsx'
import { PopupProvider } from './context/PopupContext.tsx'
import { createQueryClient } from './config/createQueryClient.ts'
import Router from './routes/index.tsx'
import { BrowserRouter } from 'react-router'
import '@/theme/global.scss'
import dayjs from './config/dayjsConfig'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/ko'
import { initSentry } from './config/sentry.ts'

// Initialize Sentry before app renders
initSentry()

dayjs.extend(relativeTime)
dayjs.locale('ko')

const CreatorApp = () => {
  const [queryClient] = useState(() => createQueryClient())
  return (
    <QueryClientProvider client={queryClient}>
      <CollableThemeProvider>
        <ToastPopupProvider>
          <PopupProvider>
            <BrowserRouter>
              <AuthProvider>
                <Router />
              </AuthProvider>
            </BrowserRouter>
          </PopupProvider>
        </ToastPopupProvider>
      </CollableThemeProvider>
    </QueryClientProvider>
  )
}

export default CreatorApp

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CreatorApp />
  </StrictMode>,
)
